export default "__VITE_ASSET__BKfPJmSv__"